import axios from 'axios'
const RESOURCE_NAME_GETOKTA_USERS = '/api/UserManagement/GetUserDetails?'
const RESOURCE_NAME_SYNC_OKTA_USERS = '/api/UserManagement/SyncUserDetailsFromOkta?'
const RESOURCE_NAME_GET_HEALTHPLAN_NAME = '/api/UserManagement/GetAllPlanNames?'
const RESOURCE_NAME_GET_CONTRACT_LIST = '/api/UserManagement/GetAllContractsForHealthPlan?'
const RESOURCE_NAME_SAVE_CONTRACT_DETAILS = '/api/UserManagement/SaveUserSurveyMappingData?'
const RESOURCE_NAME_GET_USER_CLIENT_DETAILS = '/api/UserManagement/GetUserClientDetails?'


export const UserManagementService = {
    getOktaUsers,
    syncUserDetailsFromOkta,
    getAllPlanNames,
    getAllContractsForHealthPlan,
    saveContractDetails,
    getUserClientDetails
};

function getUserClientDetails(params, cb, errorCb) {
    axios
        .get(RESOURCE_NAME_GET_USER_CLIENT_DETAILS + params)
        .then(response => (
            cb(response.data)
        ))
        .catch(error => {
            console.log(error.response)
            errorCb(error);
        });
}

function getOktaUsers(params, cb, errorCb) {
    axios
        .get(RESOURCE_NAME_GETOKTA_USERS + params)
        .then(response => (
            cb(response.data)
        ))
        .catch(error => {
            console.log(error.response)
            errorCb(error);
        });
}

function syncUserDetailsFromOkta(params, cb, errorCb) {
    axios
        .get(RESOURCE_NAME_SYNC_OKTA_USERS + params)
        .then(response => (
            cb(response.data)
        ))
        .catch(error => {
            console.log(error.response)
            errorCb(error);
        });
}

function getAllPlanNames(params, cb, errorCb) {
    axios
        .get(RESOURCE_NAME_GET_HEALTHPLAN_NAME + params)
        .then(response => (
            cb(response.data)
        ))
        .catch(error => {
            console.log(error.response)
            errorCb(error);
        });
}

function getAllContractsForHealthPlan(params, cb, errorCb) {
    axios
        .get(RESOURCE_NAME_GET_CONTRACT_LIST + params)
        .then(response => (
            cb(response.data)
        ))
        .catch(error => {
            console.log(error.response)
            errorCb(error);
        });
}

function saveContractDetails(params, cb, errorCb) {
    axios
        .post(RESOURCE_NAME_SAVE_CONTRACT_DETAILS, params)
        .then(response => (
            cb(response.data)
        ))
        .catch(error => {
            console.log(error.response)
            errorCb(error);
        });
}


